<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content style="text-align: center; padding: 40px;">
            <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-padding-bottom-20">
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldUrl" class="mat-block">
                  <input
                    id="Url"
                    matInput
                    [placeholder]="'salesforce.product_import_url' | translate"
                    formControlName="salesforceUrl"
                    [required]="isRequired('salesforceUrl')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldUserName" class="mat-block">
                  <input
                    id="UserName"
                    matInput
                    [placeholder]="'salesforce.product_import_username' | translate"
                    formControlName="salesforceUserName"
                    [required]="isRequired('salesforceUserName')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmPassword" class="mat-block">
                  <input
                    id="Password"
                    matInput
                    type="password"
                    [placeholder]="'salesforce.password' | translate"
                    formControlName="salesforcePassword"
                    [required]="isRequired('salesforcePassword')"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.gt-md="50">
                <mat-form-field id="matFrmFieldGrantType" class="mat-block">
                  <input
                    id="GrantType"
                    matInput
                    type="text"
                    [placeholder]="'salesforce.grantType' | translate"
                    formControlName="salesforceGrantType"
                    [required]="isRequired('salesforceGrantType')"
                  />
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title>{{ "salesforce.api_details" | translate }}</mat-card-title>
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketProductImportAddDisabled "
                mat-flat-button
                color="primary"
                (click)=" openEbasketProductImportSelectApiPopup();"
              >
                {{ 'salesforce.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketProductImportApiDetails')['controls']; let i = index"
            formArrayName="ebasketProductImportApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="ebasketURL"
                            [required]="isRequired('url')"
                            formControlName="url"
                            matInput
                            [placeholder]="
                    'salesforce.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="ebasketsiteid"
                            [required]="isRequired('siteId')"
                            formControlName="siteId"
                            matInput
                            [placeholder]="
                    'salesforce.sitId' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteEbasketProductImportApiDetailContainer(i);"
                >
                  {{ 'salesforce.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>
          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketProductImportApiDetails')['controls']; let i = index"
          >
            <mat-error
              *ngIf="(action !== 'view') && (!apiDetails.value.url || !apiDetails.value.siteId)"
            >
              {{"organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_and_authentication_details_required"
              | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
